// Export (Section 24.12): hand a JSON file to the browser as a download. UI-only side effect.
import type { ExportFile } from '../../store';

export function downloadFile(file: ExportFile): void {
  const blob = new Blob([file.text], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.filename;
  document.body.append(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
